import React, { Component } from "react";
import { Tooltip } from "reactstrap";
import autobind from "react-autobind";
import PropTypes from "prop-types";
import featuredImg from "./featured-sm.png";
import QRModal from "./QRModal";

export default class StoryListItem extends Component {

  constructor(props) {
    super(props);
    autobind(this);
    this.state = {
      editTooltipOpen: false,
      deleteTooltipOpen: false,
      allowDownloadTooltipOpen: false,
      allowFavouriteTooltipOpen: false,
      allowShareTooltipOpen: false,
      moreTagsTooltip: false
    };
  }

  toggleEditTooltipOpen() {
    this.setState(prevState => ({
      editTooltipOpen: !prevState.editTooltipOpen
    }));
  }

  toggleDeleteTooltipOpen() {
    this.setState(prevState => ({
      deleteTooltipOpen: !prevState.deleteTooltipOpen
    }));
  }

  toggleAllowDownloadTooltipOpen() {
    this.setState(prevState => ({
      allowDownloadTooltipOpen: !prevState.allowDownloadTooltipOpen
    }));
  }

  toggleAllowFavouriteTooltipOpen() {
    this.setState(prevState => ({
      allowFavouriteTooltipOpen: !prevState.allowFavouriteTooltipOpen
    }));
  }

  toggleAllowShareTooltipOpen() {
    this.setState(prevState => ({
      allowShareTooltipOpen: !prevState.allowShareTooltipOpen
    }));
  }

  toggleMoreTagsTooltip() {
    this.setState(prevState => ({
      moreTagsTooltip: !prevState.moreTagsTooltip
    }));
  }

  availableUntil() {
    const { endDate } = this.props;
    // show published date
    const date = new Date(endDate);
    const formatedDate = date.toLocaleDateString("en-us", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    return (
      <div>
        <span className="date">{formatedDate}</span>
      </div>
    );
  }

  getStoryStatusView(published) {
    const {
      endDate,
      isPriceSet,
      adminApproved,
      storyId,
      editStory,
      unPublishStory,
      publishStory
    } = this.props;

    if (new Date(endDate) < new Date()) {
      return undefined;
    }
    if (!isPriceSet) {
      return <span> No action available</span>;
    }

    if (isPriceSet && !adminApproved) {
      return (
        <button
          type="button"
          className="btn btn-space btn-info"
          onClick={() => {
            editStory(storyId);
          }}
        >
          <i className="icon icon-left s7-check" />
          Let&apos;s start!
        </button>
      );
    }

    if (adminApproved) {
      if (published) {
        // show published date
        // const date = new Date(this.props.publishedAt);
        // const formatedDate = date.toLocaleDateString('en-us', {day: 'numeric', month: 'long', year: 'numeric'});
        // const formatedTime = date.toLocaleTimeString('en-us', {hour: 'numeric', minute: 'numeric'});
        // return <div><span className="date">{formatedDate}</span><span
        //     className="time description">{formatedTime}</span></div>;

        return (
          <button
            type="button"
            className="btn btn-space btn-secondary"
            onClick={() => {
              unPublishStory(storyId);
            }}
          >
            <i className="icon icon-left s7-close" />
            Unpublish
          </button>
        );
      } else {
        return (
          <button
            type="button"
            className="btn btn-space btn-primary"
            onClick={() => {
              publishStory(storyId);
            }}
          >
            <i className="icon icon-left s7-cloud-upload" />
            Publish
          </button>
        );
      }
    }
    return undefined;
  }

  getStatusLabelView() {
    const { endDate, isPriceSet, adminApproved, published } = this.props;
    if (new Date(endDate) < new Date()) {
      return <span className="label label-dark"> Archived</span>;
    }
    if (!isPriceSet) {
      return <span className="label label-info"> Pending approval</span>;
    }

    if (isPriceSet && !adminApproved) {
      return <span className="label label-info">Confirmation needed</span>;
    }

    if (adminApproved) {
      if (published) {
        return <span className="label label-success">Published</span>;
      } else {
        return <span className="label label-danger">Not published</span>;
      }
    }

    return undefined;
  }

  render() {
    const availableUntil = this.availableUntil();
    const statusLabelView = this.getStatusLabelView();
    const {
      storyId,
      referenceId,
      category,
      featured,
      imagePath,
      title,
      published,
      impersonating,
      // toggleFeatured, TODO: remove/replace this prop as it is not used anymore 
      editStory,
      deleteStory,
      user,
      storyAccessLink
    } = this.props;

    const { editTooltipOpen, deleteTooltipOpen } = this.state;
    const StoryStatusView = this.getStoryStatusView(published);

    const fstyle = {
      position: "absolute",
      top: 0,
      left: 45
    };
    const featuredNode = featured ? (
      <div style={fstyle}>
        <img src={featuredImg} alt="featured" />
      </div>
    ) : null;
    const featuredControl = impersonating ? (
      <div style={fstyle}>
        <img
          className={
            featured
              ? "featured-ribbon featured-ribbon--active"
              : "featured-ribbon"
          }
          src={featuredImg}
          alt={featured ? "featured" : ""}
        />
      </div>
    ) : (
      featuredNode
    );

    return (
      <div className="items-list-item">
        <div className="list-item-1 list-item-product">
          <div className="product-image-wrapper">
            <img src={imagePath} className="product-image" alt="Story" />
          </div>
          <div className="product-details p-relative">
            {featuredControl}
            <span className="name">{title}</span>
            <span className="description">{`ID: ${referenceId}`}</span>
          </div>
        </div>
        <div className="list-item-2">{statusLabelView}</div>
        <div className="list-item-3">{availableUntil}</div>
        <div className="list-item-4 list-item-date">
          <div className="product-details p-relative">
            <span className="name">{category}</span>
          </div>
        </div>
        <div className="list-item-5 list-item-date">{StoryStatusView}</div>
        <div className="list-item-6 list-item-actions text-right">
          <span
            className="ar-icon s7-edit"
            onClick={() => {
              editStory(storyId);
            }}
            id={`editTooltip${storyId}`}
          />
          <Tooltip
            placement="top"
            isOpen={editTooltipOpen}
            target={`editTooltip${storyId}`}
            toggle={this.toggleEditTooltipOpen}
          >
            Edit Story
          </Tooltip>
          {storyAccessLink &&
            <QRModal user={user} storyId={storyId} />
          }
          <span
            className="ar-icon s7-trash"
            onClick={() => {
              deleteStory(storyId);
            }}
            id={`deleteTooltip${storyId}`}
          />
          <Tooltip
            placement="top"
            isOpen={deleteTooltipOpen}
            target={`deleteTooltip${storyId}`}
            toggle={this.toggleDeleteTooltipOpen}
          >
            Delete Story
          </Tooltip>
        </div>
      </div>
    );
  }
}

StoryListItem.propTypes = {
  endDate: PropTypes.string.isRequired,
  isPriceSet: PropTypes.bool.isRequired,
  adminApproved: PropTypes.bool.isRequired,
  published: PropTypes.bool.isRequired,
  storyId: PropTypes.string.isRequired,
  editStory: PropTypes.func.isRequired,
  unPublishStory: PropTypes.func.isRequired,
  publishStory: PropTypes.func.isRequired,
  referenceId: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  featured: PropTypes.bool,
  imagePath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  impersonating: PropTypes.bool.isRequired,
  // toggleFeatured: PropTypes.func,
  deleteStory: PropTypes.func.isRequired,
};

StoryListItem.defaultProps = {
  featured: false,
  // toggleFeatured: undefined,
}



// WEBPACK FOOTER //
// ./src/components/Story/StoryListItem.js